// Copyright (c) 2016 Deere & Company

import './customer-search-2-modal.scss';
import React, {Component, PropTypes} from 'react';
import {buildCkc2SearchFrame, sendMessageToIframe} from '../../services/customer-search-2';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import FocusTrap from 'react-focus-trap';
import {FormattedMessage} from 'react-intl';
import {WarrantyXlargeModal} from '../../../../shared/components/modal';
import {parseMessage} from '../../../../shared/services/parse-message';

class CustomerSearch2Modal extends Component {

    constructor(props) {

        super(props);
        this.onMessage = this.onMessage.bind(this);

    }

    componentDidMount() {

        window.addEventListener('message', this.onMessage);

    }

    componentWillUnmount() {

        window.removeEventListener('message', this.onMessage);

    }

    handleCustomerCreate = ckcId => {

        ckcId ? this.props.onCustomerCreate(ckcId) : this.props.onClose();

    };

    onMessage = event => {

        const parsed = parseMessage(event.data);
        const eventType = parsed.type;

        if (eventType === 'csc-loaded') {

            sendMessageToIframe(this.props.customer, this.props.route);

        }

        if (eventType === 'csc-add-customer' || eventType === 'csc-add-new-customer') {

            this::this.handleCustomerCreate(parsed.customer.entityId);

        }

    };

    render() {

        return (
            <FocusTrap active={this.props.isOpen}>
                <section className='customer-search-modal'>
                    <WarrantyXlargeModal isOpen={this.props.isOpen}>
                        <header>
                            <FormattedMessage id='CUSTOMER_SEARCH'/>
                            <span
                                className='close-modal-icon'
                                onClick={this.props.onClose}
                            />
                        </header>
                        <div className='modal-body'>
                            {buildCkc2SearchFrame('warranty-ckc-iframe', this.props.customer)}
                        </div>
                    </WarrantyXlargeModal>
                </section>
            </FocusTrap>
        );

    }

}

CustomerSearch2Modal.displayName = 'CustomerSearch2Modal';
CustomerSearch2Modal.propTypes = {
    customer: PropTypes.instanceOf(Customer).isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onCustomerCreate: PropTypes.func.isRequired,
    route: PropTypes.string.isRequired
};
CustomerSearch2Modal.defaultProps = {
    route: 'CUSTOMER_SEARCH'
};
export default CustomerSearch2Modal;



// WEBPACK FOOTER //
// ./src/product/shared/components/customer-search-2/customer-search-2-modal.js